import React from 'react'
import { ButtonGroup } from 'react-bootstrap'

import type { ShortcutConfig } from '@ztechapps/webui.util'

import { blogPermissions } from '@ztechapps/blog.common'
import { GoBackButton } from '@ztechapps/webui.button'
import { FixedPage, Page } from '@ztechapps/webui.page'
import { EmptyContent } from '@ztechapps/webui.util'

import { BlogItemProvider, useBlogItemContext } from './Context'
import { DeleteButton } from './DeleteButton'
import { useBlogPageTitle } from './hooks/useBlogPageTitle'
import { Layout } from './Layout'
import { OpenPreviewButton } from './OpenPreviewButton'
import { RefreshButton } from './RefreshButton'

export type BlogItemProps = {
  /** The host's Delete shortcut entry — registered only while the user may delete. */
  deleteShortcut: ShortcutConfig
  /** Browser-tab title prefix; PageTitle's default applies when omitted. */
  siteName?: string
}

const PageContent = ({ deleteShortcut, siteName }: BlogItemProps) => {
  const pageTitle = useBlogPageTitle()
  const { documentResult } = useBlogItemContext()

  if (documentResult.isEmpty) {
    return (
      <EmptyContent
        icon="blog"
        action={<GoBackButton />}
        message="Blog detail cannot be shown."
        subMessage="Blog does not exist or you do not have permission to view it."
      />
    )
  }

  return (
    <Page roleName={blogPermissions.canView.value}>
      <FixedPage.Header
        title={pageTitle}
        siteName={siteName}
        actions={
          <ButtonGroup>
            <GoBackButton />
            <RefreshButton />
            <OpenPreviewButton />
            <DeleteButton deleteShortcut={deleteShortcut} />
          </ButtonGroup>
        }
      />
      <FixedPage.Body>
        <Layout />
      </FixedPage.Body>
    </Page>
  )
}

export const BlogItem = (props: BlogItemProps) => (
  <BlogItemProvider>
    <PageContent {...props} />
  </BlogItemProvider>
)
